import { bindActionCreators } from "redux";
import * as counterActions from "./counter/actions";
import { dispatch } from ".";

export const counter = bindActionCreators(counterActions, dispatch);
